
export default (theme) => ({

  Accordian: {
    '&:before': {
      display: 'none',
    },
    marginTop: '14px',
    width: '100%',
    padding: '14px',
    boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.2), inset 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 6px 0px rgba(0, 0, 0, 0.12)',
    bordeRadius: "8px",
    "border": `1px solid ${theme.palette.colors.ceruleanMain}`,
  },
  Summary: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0px',
  },
  ExpandIcon: {
    color: 'blue', // Change the color to blue
  },
  ScheduleName: {
    fontWeight: 'bold',
  },
  SaveButton: {
    marginRight: '8px !important',
  },
  CreationDate: {
    fontSize: 15,
    color: theme.palette.primary.black, // Adjust color
    marginTop: '5px',
  },
  Details: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '32px',
  },
  DetailItem: {
    marginBottom: '10px', // Space between detail items
    display: 'flex',
    flexDirection: 'column',
  },
  /** Default title for block / full-width blocks only — do not use in horizontal label+control rows */
  DetailTitle: {
    fontWeight: 'bold',
    width: '100%',
  },
  /**
   * Fixed width so "Schedule name", "Max minutes per call", and "Max minutes per" start on one vertical line.
   * (Percent/maxWidth caused uneven left edges and awkward gaps.)
   */
  FieldRowLabel: {
    fontWeight: 'bold',
    flex: '0 0 200px',
    width: 200,
    minWidth: 0,
    alignSelf: 'center',
    lineHeight: '24px',
    fontSize: 16,
    textAlign: 'left',
  },
  MaxMinutesLabel: {
    flex: 'none',
    width: 'auto',
    marginRight: '12px',
  },
  /**
   * Same width as `MinuteCapPeriodSelect` (112px) + same gap as between select and stepper on the row below.
   * Keeps the per-call stepper’s +/- aligned with the cap row stepper.
   */
  CapPeriodSpacer: {
    flex: '0 0 112px',
    width: 112,
    minHeight: 1,
  },
  /** All edit rows: fixed label, remaining space to the right. */
  EditFormRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    columnGap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  /**
   * Pushes the period slot + stepper to the end of the row. Same child structure on
   * “Max minutes per call” and “Max minutes per” so both steppers line up vertically.
   */
  EditFormRowEndControls: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    minWidth: 0,
    columnGap: theme.spacing(2),
    '& > *': { flexShrink: 0 },
  },
  /** Stacked read-only view: label full width of column (Figma) */
  ViewFieldTitle: {
    fontWeight: 'bold',
    width: '100%',
    display: 'block',
    lineHeight: '24px',
    fontSize: 16,
  },
  CallScheduleHeading: {
    fontWeight: 'bold',
    width: '100%',
    marginBottom: '14px',
  },
  DetailItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    columnGap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  /** Figma: label + value on two lines in view mode */
  ViewField: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  ValueLine: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 6,
    fontSize: 16,
    lineHeight: '24px',
    color: theme.palette.primary.black,
  },
  ValueLineSuffix: {
    fontWeight: 400,
  },
  ButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
  },
  EditButton: {
    marginLeft: '16px !important',
    marginTop: '16px !important',
  },
  Divider: {
    margin: '16px 0',
  },
  DeleteContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  Modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  },
  ModalIcon: {
    fontSize: '2rem',
    color: 'white',
  },

  ModalButton: {
    minWidth: '80px',
    marginRight: '8px !important',
  },

  DeleteAvatar: {
    backgroundColor: theme.palette.colors.redMain,
    width: '50px',
    height: '50px',
  },

  ModalButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(4),
  },
});
